import React, { useEffect, useState } from "react";
import { V_URL_API } from "../../../../../../../../utils/config";

export default function Subtitulos({
  videoRef,
  vLeccion,
  vIsSubtitulos = false,
}) {
  const [events, setEvents] = useState([]);
  const [visibleEvents, setVisibleEvents] = useState([]);

  // 🔁 Cargar subtítulos
  useEffect(() => {
    if (vIsSubtitulos && events.length === 0) {
      fetch(`${V_URL_API}/api/subtitulos/json/${vLeccion.leccion_subtitulos}`)
        .then((res) => res.json())
        .then((data) => setEvents(data.events));
    }
  }, [vIsSubtitulos]);

  // 🎯 Actualiza lista de eventos visibles (máx. 2)
  useEffect(() => {
    const video = videoRef.current;
    if (!video || events.length === 0) return;

    const interval = setInterval(() => {
      const currentTimeMs = video.currentTime * 1000;

      const activeEvents = events.filter(
        (e) =>
          currentTimeMs >= e.tStartMs &&
          currentTimeMs <= e.tStartMs + e.dDurationMs
      );

      setVisibleEvents((prev) => {
        const newEvents = activeEvents.filter(
          (e) => !prev.some((p) => p.id === e.id)
        );
        const updated = [...prev, ...newEvents];
        return updated.slice(-2); // mantener los últimos 2
      });
    }, 100);

    return () => clearInterval(interval);
  }, [events, videoRef]);

  // 🎯 Mostrar progresivamente las palabras
  const getVisibleText = (event) => {
    const video = videoRef.current;
    if (!video) return "";

    const currentTimeMs = video.currentTime * 1000;
    const offset = currentTimeMs - event.tStartMs;

    const visibleWords = event.segs
      .filter((seg) => (seg.tOffsetMs ?? 0) <= offset)
      .map((seg) => seg.utf8);

    return visibleWords.join(" ");
  };

  if (!vIsSubtitulos) return null;

  return (
    <div
      style={{
        position: "absolute",
        bottom: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      {visibleEvents.map((event) => (
        <div
          key={event.id}
          className="subtitulos-texto"
        >
          {getVisibleText(event)}
        </div>
      ))}
    </div>
  );
}
